import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ajaxCall } from './axios'

const initialState = {
  fromInit: false,
  printsStack: [],
  currentPrintItem: null,
}

const getCurrentPrintIindex = (params = {}, printsStack) =>
  printsStack
    .filter((item) => !!item)
    .findIndex(
      (item) => item.params.userUid === params.userUid && item.params.timestamp === params.timestamp
    )

export const printSlice = createSlice({
  name: 'print',
  initialState,
  reducers: {
    print: (state, action) => {
      if ((action.payload || {}).labels) {
        state.fromInit = (action.payload || {}).fromInit

        state.currentPrintItem = action.payload

        state.printsStack = [...state.printsStack, action.payload]
      }
    },
    printStatus: (state, action) => {
      if (getCurrentPrintIindex(action.payload.params, state.printsStack) > -1) {
        state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)] = {
          ...state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)],
          status: 'progress',
          progress: action.payload.progress,
        }

        if (action.payload.params.customPrintName) {
          state.printsStack[
            getCurrentPrintIindex(action.payload.params, state.printsStack)
          ].labels.name = action.payload.params.customPrintName
        }
      }

      state.fromInit = false

      state.currentPrintItem = null
    },
    printStatusWaiting: (state, action) => {
      if (getCurrentPrintIindex(action.payload.params, state.printsStack) > -1) {
        state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)].status =
          'waiting'

        if (action.payload.params.customPrintName) {
          state.printsStack[
            getCurrentPrintIindex(action.payload.params, state.printsStack)
          ].labels.name = action.params.customPrintName
        }
      }

      state.fromInit = false

      state.currentPrintItem = null
    },
    printStatusError: (state, action) => {
      if (getCurrentPrintIindex(action.payload.params, state.printsStack) > -1) {
        state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)] = {
          ...state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)],
          status: 'error',
          message: action.payload.message,
        }
      }

      state.fromInit = false

      state.currentPrintItem = null
    },
  },
  printStatusDone: (state, action) => {
    if (getCurrentPrintIindex(action.payload.params, state.printsStack) > -1) {
      state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)] = {
        ...state.printsStack[getCurrentPrintIindex(action.payload.params, state.printsStack)],
        status: 'done',
        progress: 100,
        pdf: action.payload.pdf,
      }
    }

    state.fromInit = false

    state.currentPrintItem = null
  },
  printStatusRemove: (state, action) => {
    if (getCurrentPrintIindex(action.payload.params, state.printsStack) > -1) {
      state.printsStack.splice(getCurrentPrintIindex(action.payload.params, state.printsStack), 1)
    }
  },
  printClose: (state) => {
    state.fromInit = false

    state.currentPrintItem = null
  },
})

export const printPost = createAsyncThunk('print/post', async (data, thunkAPI) => {
  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: data.url,
        method: 'post',
        data: {
          ...data,
          savePdf: '1',
        },
      },
      success: (res) => {
        thunkAPI.dispatch(print(res.data))
      },
      error: () => {},
      activeLoading: true,
    })
  )
})

export const printCancel = createAsyncThunk('print/cancel', async (data, thunkAPI) => {
  const { appConfig } = thunkAPI.getState().app

  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: appConfig.actions.print.cancel.path,
        method: 'get',
        data,
      },
      success: () => {},
      error: () => {},
      activeLoading: false,
    })
  )

  thunkAPI.dispatch(printStatusRemove(data))
})

export const prints = createAsyncThunk('print/prints', async (data, thunkAPI) => {
  ;(data || []).forEach((elem) => {
    thunkAPI.dispatch(print(elem))
  })
})

export const printStatusGet = createAsyncThunk('print/statusGet', async (params, thunkAPI) => {
  const { appConfig } = thunkAPI.getState().app

  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: appConfig.actions.print.status.path,
        method: 'get',
        params,
      },
      success: (res) => {
        const { data } = res.data

        const timeoutId = Object.values(params).join('-')

        if (data.customPrintName) {
          params.customPrintName = data.customPrintName
        }

        switch (data.status) {
          case 'waiting':
          case 'progress':
            if (data.status === 'waiting') {
              thunkAPI.dispatch(printStatusWaiting(params))
            } else {
              thunkAPI.dispatch(printStatus(data.progress, params))
            }

            if (!appConfig.timeouts.printStatus) {
              appConfig.timeouts.printStatus = {}
            }

            if (appConfig.timeouts.printStatus[timeoutId]) {
              clearTimeout(appConfig.timeouts.printStatus[timeoutId])
            }

            appConfig.timeouts.printStatus[timeoutId] = setTimeout(() => {
              thunkAPI.dispatch(printStatusGet(params))
            }, appConfig.actions.print.printStatus.timeout)

            return ''
          case 'error':
            return thunkAPI.dispatch(printStatusError(data.message, params))
          default:
            return thunkAPI.dispatch(printStatusDone(data.pdf, params))
        }
      },
      error: () => {},
      activeLoading: false,
    })
  )
})

export const {
  print,
  printStatus,
  printStatusError,
  printStatusWaiting,
  printStatusDone,
  printStatusRemove,
  printClose,
} = printSlice.actions

export default printSlice.reducer
